import axiosClient from './axiosClient';

const SELECTED_MENU_STORAGE_KEY = 'selected_menu_id';

const getSelectedMenuId = () => {
  return localStorage.getItem(SELECTED_MENU_STORAGE_KEY) || '';
};

const withSelectedMenu = (params = {}) => {
  const menuId =
    params.menu_id ||
    getSelectedMenuId();

  return {
    ...params,
    ...(menuId
      ? {
          menu_id: menuId,
        }
      : {}),
  };
};

const normalizeOrderPayload = (payload = {}) => {
  const menuId =
    payload.menu_id ||
    getSelectedMenuId();

  return {
    ...payload,
    menu_id: menuId || '',
  };
};

export const ordersApi = {
  getOrders(establishmentId, params = {}) {
    return axiosClient.get(
      `/establishments/${establishmentId}/orders`,
      {
        params: withSelectedMenu(params),
      },
    );
  },

  getOrder(orderId) {
    return axiosClient.get(
      `/orders/${orderId}`,
    );
  },

  createOrder(establishmentId, payload) {
    return axiosClient.post(
      `/establishments/${establishmentId}/orders`,
      normalizeOrderPayload(payload),
    );
  },

  updateOrderStatus(orderId, status) {
    return axiosClient.patch(
      `/orders/${orderId}/status`,
      {
        status,
      },
    );
  },
};

export default ordersApi;